
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.462 1.392a1.894 1.894 0 012.677-.057l3.908 3.745-9.43 9.84a6.183 6.183 0 11-2.734-2.62l2.63-2.745-2.3-2.205a1.894 1.894 0 012.62-2.734l2.3 2.204 1.56-1.626-1.174-1.125a1.894 1.894 0 01-.057-2.677zM10.833 16.13a2.396 2.396 0 10-3.315 3.46 2.396 2.396 0 003.315-3.46z","fill":"#5935DD"}}),_c('path',{attrs:{"d":"M6.975 18.685a6.326 6.326 0 11-2.477 2.924","stroke":"#fff"}}),_c('circle',{attrs:{"cx":"23.281","cy":"15.5","r":"3.821","fill":"#E345FF"}})])
          )
        }
      }
    